import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    sectionNameListLoading: false,
    sectionNameListSuccess: null,
    sectionNameListError: '',

    getSectionNameLoading: false,
    getSectionNameSuccess: null,
    getSectionNameError: '',

    createSectionNameLoading: false,
    createSectionNameSuccess: {},
    createSectionNameError: '',
}

export const sectionNameSlice = createSlice({
    name: 'sectionName',
    initialState, 
    reducers: {
        setSectionNameListLoading: (state) => {
            state.sectionNameListLoading = true;
            state.sectionNameListSuccess = null;
            state.sectionNameListError = '';
        },
        setSectionNameListSuccess: (state, action) => {
            state.sectionNameListLoading = false;
            state.sectionNameListSuccess = action.payload;
            state.sectionNameListError = '';
        },
        setSectionNameListError: (state, action) => {
            state.sectionNameListLoading = false;
            state.sectionNameListSuccess = null;
            state.sectionNameListError = action.payload;
        },
        setGetSectionNameLoading: (state) => {
            state.getSectionNameLoading = true;
            state.getSectionNameSuccess = {};
            state.getSectionNameError = '';
        },
        setGetSectionNameSuccess: (state, action) => {
            state.getSectionNameLoading = false;
            state.getSectionNameSuccess = action.payload;
            state.getSectionNameError = '';
        },
        setGetSectionNameError: (state, action) => {
            state.getSectionNameLoading = false;
            state.getSectionNameSuccess = {};
            state.getSectionNameError = action.payload;
        },
        setCreateSectionNameLoading: (state) => {
            state.createSectionNameLoading = true;
            state.createSectionNameSuccess = {};
            state.createSectionNameError = '';
        },
        setCreateSectionNameSuccess: (state, action) => {
            state.createSectionNameLoading = false;
            state.createSectionNameSuccess = action.payload;
            state.createSectionNameError = '';
        },
        setCreateSectionNameError: (state, action) => {
            state.createSectionNameLoading = false;
            state.createSectionNameSuccess = {};
            state.createSectionNameError = action.payload;
        },
        resetDetails: (state) => {
            state.getSectionNameSuccess = {};
            state.createSectionNameSuccess = {};
        },
    }
})

export const { setSectionNameListLoading, setSectionNameListSuccess, setSectionNameListError,
    setGetSectionNameLoading, setGetSectionNameSuccess, setGetSectionNameError, 
    setCreateSectionNameLoading, setCreateSectionNameSuccess, setCreateSectionNameError,
    resetDetails
} = sectionNameSlice.actions;


export default sectionNameSlice.reducer;